import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ChatState {
  chatId: string | null;
  agentId: string | null;
}

const initialState: ChatState = {
  chatId: null,
  agentId: null,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatContext: (
      state,
      action: PayloadAction<{ chatId: string; agentId: string }>
    ) => {
      state.chatId = action.payload.chatId;
      state.agentId = action.payload.agentId;
    },
    clearChatContext: (state) => {
      state.chatId = null;
      state.agentId = null;
    },
  },
});

export const { setChatContext, clearChatContext } = chatSlice.actions;
export default chatSlice.reducer;
